<template>
  <v-row no-gutters>
    <v-col>
      <v-dialog v-model="dialogHarici" scrollable max-width="1500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <span v-if="dialogHariciType === 0"> Harici Mağazalar </span>
            <span v-else> Dahili Mağazalar </span>
            <v-spacer></v-spacer>
            <v-btn class="text-caption" color="night" rounded @click="dialogHarici = !dialogHarici"
              >Kapat</v-btn
            >
          </v-card-title>
          <v-card-text class="pa-0" style="max-height: 6500px">
            <v-data-table
              :headers="hariciMusterilerHeaders"
              :items="hariciMusterilerItems"
              :items-per-page="10"
              class="elevation-1"
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div id="product-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <product-add-update
          v-model="isAddUpdateProductSidebarActive"
          :product-type="productType"
          :product-item="productItem"
          @refetch-data="tableFetch"
          @upload-image="uploadImage"
          @save-product-event="saveProductEvent"
        ></product-add-update>

        <Image-upload
          v-model="isUploadProductImageActive"
          :data="dataUpload"
          @refetch-data="tableFetch"
          @save-image-event="saveImageEvent"
        />
        <v-snackbars
          :objects.sync="snackbars"
          width="500"
          top
          right
          transition="slide-y-transition"
        >
          <template v-slot:action="{ close }">
            <v-btn icon small @click="close()">
              <v-icon small>
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </template>
        </v-snackbars>

        <v-dialog v-model="dialogResim" max-width="800">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn outlined color="error" @click="dialogResim = false"> Kapat </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <img :src="$baseUrlAPI + '' + resimUrl" width="800" />
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-card tile :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'">
          <PageHeader>
            <template #action>
              <v-checkbox
                v-model="loadAll"
                dense
                hide-details
                class="ma-0 ml-2"
                color="primary"
                label="Hepsini Yükle"
              />
            </template>
          </PageHeader>

          <!-- table -->
          <v-data-table
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            :items-per-page="loadAll ? 1000 : 20"
            :mobile-breakpoint="100"
            :height="pageStore.tableHeight"
            fixed-header
            hide-default-footer
            loader-height="2"
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
          >
            <!-- Load More -->
            <template v-slot:body.append v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr class="data-table-body-search">
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchCode"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchCategorie"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchTitle"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
              </tr>
            </template>

            <template #[`item.urun_kodu`]="{ item }">
              <v-chip label color="chip">
                <span style="font-size: 11px !important; letter-spacing: 0.5px; color: azure">
                  {{ item.urun_kodu }}</span
                >
              </v-chip>
            </template>

            <template #[`item.kategori`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="text-truncate text-uppercase"
                  style="
                    width: 200px !important;
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  {{ item.kategori }}
                </div>
              </v-chip>
            </template>

            <template #[`item.baslik`]="{ item }">
              <div class="d-flex align-center">
                <div class="mr-2">
                  <v-tooltip v-if="item.pictures" left color="white">
                    <template v-slot:activator="{ on, attrs }">
                      <v-hover v-slot="{ hover }">
                        <v-sheet
                          width="32"
                          height="32"
                          :color="hover ? 'error' : 'secondary'"
                          class="d-flex align-center justify-center cursor-pointer"
                          @click="productImageDelete(item)"
                          rounded
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="white" size="18" v-bind="attrs" v-on="on">
                                {{ hover ? icons.mdiTrashCan : icons.mdiCamera }}
                              </v-icon>
                            </template>
                            <span>Resimi Sil</span>
                          </v-tooltip>
                        </v-sheet>
                      </v-hover>
                    </template>
                    <v-img
                      width="300"
                      height="300"
                      :src="$baseUrlAPI + '' + item.pictures.dresim[0].dosya_adi"
                    ></v-img>
                  </v-tooltip>
                  <v-hover v-slot="{ hover }" v-else>
                    <v-sheet
                      width="32"
                      height="32"
                      color="primary"
                      class="d-flex align-center justify-center cursor-pointer"
                      rounded
                      @click="productImageUpload(item)"
                    >
                      <v-tooltip left color="secondary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="white" size="18" v-bind="attrs" v-on="on">
                            {{ hover ? icons.mdiUpload : icons.mdiCameraOff }}
                          </v-icon>
                        </template>
                        <span>Resim Yükle</span>
                      </v-tooltip>
                    </v-sheet>
                  </v-hover>
                </div>
                <div>
                  <div class="text-body-2 white--text">{{ baslikSplit(item.baslik, 0) }}</div>
                  <div class="primary--text text-caption" style="line-height: 1">
                    {{ baslikSplit(item.baslik, 1) }}
                  </div>
                </div>
              </div>
            </template>

            <template #[`item.satis_fiyati`]="{ item }">
              <div v-if="item.satis_fiyati" class="text-overline white--text font-weight-medium">
                {{ item.satis_fiyati | currency }}
              </div>
            </template>

            <template #[`item.kdv_orani`]="{ item }">
              <div v-if="item.kdv_orani" class="text-overline">
                {{ $store.state.tanimlar.kdv.find((el) => el.value === item.kdv_orani).text }}
              </div>
            </template>

            <template #[`item.birim`]="{ item }">
              <v-chip class="d-flex justify-center" label>
                <div
                  class="text-truncate text-uppercase"
                  style="
                    width: 60px !important;
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  {{ unitText(item.birim) }}
                </div>
              </v-chip>
            </template>

            <template #[`item.harici_musteri_sayisi`]="{ item }">
              <div v-if="Number(item.harici_musteri_sayisi) > 0" class="d-flex align-center">
                <v-chip
                  color="warning"
                  label
                  outlined
                  @click="hariciListe(item)"
                  class="cursor-default"
                >
                  {{ item.harici_musteri_sayisi }} Harici
                </v-chip>

                <v-chip
                  color="success"
                  label
                  outlined
                  @click="dahiliListe(item)"
                  class="cursor-default ml-2"
                >
                  {{item.dahili_musteri_sayisi }} Dahili
                </v-chip>
              </div>
              <v-chip
                v-else
                outlined
                label
                class="d-flex align-center justify-center text--disabled"
                >Hepsi</v-chip
              >
            </template>

            <template v-if="userData.role !== 'MNGR'" #[`item.actions`]="{ item }">
              <v-btn
                depressed
                style="height: 32px !important"
                color="chip"
                class="text-capitalize ml-2"
                @click="editProduct(item)"
              >
                Düzenle
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ImageUpload from "@/components/ImageUpload.vue";
import store from "@/store";
import { postData } from "@utils";
import {
  mdiTrashCan,
  mdiCamera,
  mdiCameraOff,
  mdiUpload,
  mdiClose,
  mdiChefHat,
  mdiDelete,
  mdiDownload,
  mdiEye,
  mdiMagnify,
  mdiPlusThick,
  mdiSquareEditOutline,
} from "@mdi/js";
import { onUnmounted, computed, onMounted, ref, watch } from "vue-demi";
import VSnackbars from "v-snackbars";
import Vue from "vue";
import productAddUpdate from "./ProductAddUpdate.vue";
import PageHeader from "@/components/PageHeader/Index.vue";
import { usePageStore } from "@/stores/pageHeader";
import _ from "lodash";
// Plugin
import { useToast } from "vue-toastification/composition";
import { useDebounceFn } from "@vueuse/core";

const userData = JSON.parse(localStorage.getItem("userData"));

export default {
  components: {
    productAddUpdate,
    PageHeader,
    ImageUpload,
    VSnackbars,
  },
  setup() {
    const pageStore = usePageStore();

    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = "Mamül Ürünler";
      pageStore.pageIcon = mdiChefHat;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = true;

      pageStore.downloadHeader = {
        "Ürün Kodu": "urun_kodu",
        Kategori: "kategori",
        "Ürün Adı": "baslik",
        Fiyat: "satis_fiyati",
        KDV: "kdv_orani",
        Birim: "birim",
        Mağaza: "harici_musteri_sayisi",
      };
    };

    const toast = useToast();

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);
    const loadAll = ref(false);

    // Table Columns
    const tableColumns = ref([
      {
        text: "Ürün Kodu",
        value: "urun_kodu",
        width: "130px",
        sortable: false,
      },
      {
        text: "Kategori",
        value: "kategori",
        width: "250px",
        sortable: false,
      },
      {
        text: "Ürün Adı",
        value: "baslik",
        align: "left min-width-400",
        sortable: false,
      },
      {
        text: "Fiyat",
        value: "satis_fiyati",
        width: "130px",
        align: "right",
        sortable: false,
      },
      {
        text: "KDV",
        value: "kdv_orani",
        width: "60px",

        sortable: false,
      },
      {
        text: "Birim",
        value: "birim",
        width: "100px",
        sortable: false,
      },
      {
        text: "Mağaza",
        value: "harici_musteri_sayisi",
        width: "110px",
        sortable: false,
      },
      {
        text: "",
        value: "actions",
        align: "right",
        width: "100",
        sortable: false,
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableSearchTitle = ref("");
    const tableSearchCategorie = ref("");
    const tableSearchCode = ref("");
    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
      itemsPerPage: 20,
    });

    // Düzenle
    const dialogResim = ref(false);
    const resimUrl = ref(null);
    const dialogResimDurum = (val) => {
      dialogResim.value = true;
      resimUrl.value = val;
    };

    const snackbars = ref([]);

    const isAddUpdateProductSidebarActive = ref(false);
    const isUploadProductImageActive = ref(false);
    const dataUpload = ref({});

    const productType = ref("add");
    const productItem = ref({});
    const kodSearch = ref("");
    const kategoriSearch = ref("");

    const searchQuery = ref("");
    const urunKodFilter = ref(null);
    const idFilter = ref(null);
    const statusFilter = ref(null);
    const baslikFilter = ref(null);
    const customerFilter = ref(null);

    const customerGroupOptions = ref([]);
    const pricelistOptions = ref([]);

    const selectedRows = ref([]);

    const productImageUpload = (item) => {
      dataUpload.value = item;
      isUploadProductImageActive.value = true;
    };
    const uploadImage = (item) => {
      dataUpload.value = item;
      isUploadProductImageActive.value = true;
    };
    const statusFind = (arr, value, select) =>
      store.state.tanimlar[arr].find((item) => item.value === value)[select];

    const productImageDelete = (item) => {
      Vue.swal({
        title: "Emin misin?",
        text: "Resimi silme işlemini onaylayın",
        icon: "question",
        background: "#FFB400",
        showCancelButton: true,
        showCloseButton: false,
        width: "300px",
        confirmButtonText: "Onaylıyorum",
        cancelButtonColor: "#FFB400",
        confirmButtonColor: "#cc9000",
      }).then((result) => {
        if (result.isConfirmed) {
          tableLoading.value = true;
          store
            .dispatch("postMethod", {
              method: "removeMediaItem",
              uploadid: item.pictures.bresim[0].uploadid,
            })
            .then(() => {
              snackbars.value.push({
                message: `${item.baslik} Ürünün Resmi Silindi`,
                color: "error",
                timeout: 3000,
              });

              tableFetch();
            })
            .catch((e) => {
              Vue.swal({
                title: "Hata",
                text: e.message,
                width: "350px",
                icon: "error",
                background: "#FF4C51",
                showCloseButton: false,
                showConfirmButton: true,
                confirmButtonColor: "#cc3d41",
              });
            });
        }
      });
    };

    const saveProductEvent = (val) => {
      snackbars.value.push(val);
    };

    const saveImageEvent = (val) => {
      snackbars.value.push(val);
    };

    const editProduct = (item) => {
      productItem.value = item;
      productType.value = "edit";
      isAddUpdateProductSidebarActive.value = true;
    };

    const json_data = ref([]);

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch([tableSearchTitle, tableSearchCategorie, tableSearchCode], () => {
      loadMoreLoading.value = false;
      tableLoading.value = true;
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableItems.value = [];
      // Download (Excel/PDF) datasını da sıfırla
      pageStore.downloadData = [];

      debouncedTableSearch();
    });

    watch(loadAll, (val) => {
      loadMoreLoading.value = false;
      tableLoading.value = true;
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableOptions.value.itemsPerPage = val ? 1000 : 20;
      tableItems.value = [];
      pageStore.downloadData = [];
      tableFetch();
    });

    const tableFetch = () => {
      tableLoading.value = true;

      postData({
        method: "adminProductList",
        options: JSON.stringify(tableOptions.value),
        search: JSON.stringify({
          mattype: "MAMUL",
          baslik: tableSearchTitle.value,
          kategori: tableSearchCategorie.value,
          urun_kodu: tableSearchCode.value,
        }),
      })
        .then(async (response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalCount);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.response.result.map((item) => {
            tableItems.value.push({ ...item });
          });

          // Download (Excel/PDF) için kullanılacak veri
          pageStore.downloadData = tableItems.value;

          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
        });
    };

    onMounted(() => {
      pageSettings();
      tableFetch();
    });
    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    const dialogHarici = ref(false);
    const dialogHariciType = ref(0);

    const hariciMusterilerHeaders = [
      { text: "Id", value: "id" },
      { text: "Müşteri No", value: "customer" },
      { text: "Müşteri", value: "name1" },
      { text: "Ofis Ad", value: "officename" },
      { text: "Telefon", value: "telnum" },
      { text: "E-Posta", value: "email" },
    ];
    const hariciMusterilerItems = ref([]);

    const hariciListe = (item) => {
      hariciMusterilerItems.value = [];

      postData({
        method: "getCustomersByInternalOrExternal",
        product_id: item.urun_kodu,
        type: "external",
      }).then((response) => {
        if (response.error === 0) {
          hariciMusterilerItems.value = response.detail;
          dialogHarici.value = true;
          dialogHariciType.value = 0;
        }
      });
    };

    const dahiliListe = (item) => {
      hariciMusterilerItems.value = [];

      postData({
        method: "getCustomersByInternalOrExternal",
        product_id: item.urun_kodu,
        type: "internal",
      }).then((response) => {
        if (response.error === 0) {
          hariciMusterilerItems.value = response.detail;
          dialogHarici.value = true;
          dialogHariciType.value = 0;
        }
      });
    };

    const pdfColumns = ref(["Ürün Kodu", "Kategori", "Ürün Adı", "Fiyat", "KDV", "Birim"]);

    const baslikSplit = (val, index) => {
      let result;
      if (val.split("(").length > 1) {
        if (index === 0) {
          result = val.split("(")[index].slice(0, -1);
        } else {
          result = `(${val.split("(")[index].slice(0, -1)})`;
        }
      } else if (index === 0) {
        result = val;
      }

      return result;
    };

    const unitText = (item) => {
      return store.state.tanimlar.birim.find((el) => el.value === item)?.text || "TANIMSIZ";
    };
    return {
      loadMore,
      loadMoreLoading,
      loadAll,
      unitText,
      baslikSplit,
      pdfColumns,
      hariciMusterilerHeaders,
      hariciMusterilerItems,
      dialogHarici,
      dialogHariciType,
      hariciListe,
      dahiliListe,
      userData,
      dialogResim,
      resimUrl,
      dialogResimDurum,
      json_data,
      productImageDelete,
      statusFind,
      kodSearch,
      kategoriSearch,
      tableSearchTitle,
      tableSearchCategorie,
      tableSearchCode,
      productItem,
      editProduct,

      productType,
      pageStore,
      tableItems,
      tableColumns,
      searchQuery,
      urunKodFilter,
      baslikFilter,
      idFilter,
      statusFilter,

      tableLoading,
      tableOptions,
      tableTotalRec,
      isAddUpdateProductSidebarActive,
      isUploadProductImageActive,
      selectedRows,
      tableFetch,

      snackbars,
      productImageUpload,
      dataUpload,
      uploadImage,
      saveProductEvent,
      saveImageEvent,
      customerFilter,
      customerGroupOptions,
      pricelistOptions,

      // icons
      icons: {
        mdiTrashCan,
        mdiUpload,
        mdiCamera,
        mdiDelete,
        mdiCameraOff,
        mdiChefHat,
        mdiEye,
        mdiPlusThick,
        mdiDownload,
        mdiSquareEditOutline,
        mdiClose,
        mdiMagnify,
      },
    };
  },
  data() {
    return {
      itemsPerPage: null,
      panel: null,
      date: null,
      modal: false,
      filterStatus: false,
      dataTableHeight: "",
      json_fields: {
        "Ürün Kodu": "urun_kodu",
        Kategori: "kategori",
        "Ürün Adı": "baslik",
        Fiyat: "satis_fiyati",
        KDV: "kdv_orani",
        Birim: "birim",
        Harici: "harici_musteri_sayisi",
      },
      height: {
        system: 0,
        top: this.$vuetify.breakpoint.smAndDown ? 48 : 87,
        footer: this.$vuetify.breakpoint.smAndDown ? 47 : 47,
      },
    };
  },

  watch: {
    panel(val) {
      if (val === 0) {
        setTimeout(() => {
          this.height.top = 250;
          this.onResize();
        }, 300);
      } else {
        this.height.top = 48;
        this.onResize();
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.onResize();
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.itemsPerPage = Math.ceil(window.innerHeight / 100) + 4;
      if (userData.role === "SUPER") {
        this.dataTableHeight = window.innerHeight - 128;
      } else {
        this.dataTableHeight = window.innerHeight - 90 - this.height.top - this.height.footer - 1;
      }

      const r = document.querySelector(":root");
      r.style.setProperty("--height", `${(this.dataTableHeight - 100) / this.itemsPerPage}px`);
    },
  },
};
</script>
